import * as React from 'react';
import { HiddenInput, CustomButton, ButtonType } from "soprasteria-ui-library";
import { IOrthodonticReferral, IOrthodonticReferralAttachment } from '../../../../models/IOrthodonticReferral';
import { useAuth } from '../../../../App';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';
import { OrthodonticReferralApi } from '../../../../api/OrthodonticReferralApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { LibrettoFileUpload } from '../../../FileUpload/LibrettoFileUpload';
import { OrthodonticReferralUploadFilesConsultantButton } from '../OrthodonticReferralButtons/OrthodonticReferralUploadFilesConsultantButton';

interface IOrthodonticReferralFileSection {
    orthodonticReferral: IOrthodonticReferral;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
}

export const OrthodonticReferralFileSection: React.FunctionComponent<IOrthodonticReferralFileSection> = ({ orthodonticReferral, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral } )=> {

    const auth = useAuth();
    const orthodonticReferralAdministrationApi = new OrthodonticReferralAdministrationApi(auth);
    const orthodonticReferralApi = new OrthodonticReferralApi(auth);
    const [orthodonticReferralAttachmentCategories, setOrthodonticReferralAttachmentCategories] = React.useState<IListItem[]>();
    const [attachments, setAttachments] = React.useState<IOrthodonticReferralAttachment[]>();
    const [filesSelected, setfilesSelected] = React.useState<boolean>();

    React.useEffect(() => {
        setAttachments(orthodonticReferral.attachments);
    }, [orthodonticReferral.attachments])

    React.useEffect(() => {
        if (orthodonticReferral.canEdit || orthodonticReferral.canUploadFileAsConsultant) {
            orthodonticReferralAdministrationApi.getOrthodonticReferralAttachmentCategories((categories) => {
                const newCategories = categories.map<IListItem>((category) => {
                    return { text: category.description, value: category.orthodonticReferralAttachmentCategoryId.toString() }
                });
                setOrthodonticReferralAttachmentCategories(newCategories);
            });
        }
    }, [orthodonticReferral.canEdit, orthodonticReferral.canUploadFileAsConsultant]);

    const removeFile = (id: number) => {
        const removeFileFromDB = window.confirm("Är du säker på att du vill ta bort den här bilagan?");
        if (removeFileFromDB) {
            if (!orthodonticReferral.isCopy) {
                orthodonticReferralAdministrationApi.removeOrthodonticReferralAttachment(id.toString(), () => {
                    setAttachments(attachments?.filter((file) => file.orthodonticReferralAttachmentId !== id))
                });
            }
            else {
                setAttachments(attachments?.filter((file) => file.orthodonticReferralAttachmentId !== id))
            }
        }
    }

    const hasDownloadableDocuments = () => {
        if (orthodonticReferral?.attachments) {
            return orthodonticReferral.attachments.some(data => data.isDownloadable);
        } else {
            return false;
        }
    }

    const downloadAllDocuments = () => {
        if (orthodonticReferral?.attachments) {
            let downloadableAttachments = orthodonticReferral.attachments.filter(data => data.isDownloadable);
            downloadableAttachments.forEach((orthodonticReferralAttachment) => {
                downloadDocument(orthodonticReferralAttachment.orthodonticReferralAttachmentId, orthodonticReferralAttachment.name);
            });
        }        
    }

    const downloadDocument = (orthodonticReferralAttachmentId: number, fileName?: string) => {
        orthodonticReferralApi.downloadOrthodonticReferralAttachment(orthodonticReferralAttachmentId, fileName,
            (error) => {
                alert(error);
            });
    }

    const canUploadFile = () => {
        return orthodonticReferral.orthodonticReferralId === undefined || orthodonticReferral.canEdit || orthodonticReferral.canUploadFileAsConsultant;
    }

    const isAnyAttachmentRemovable = () => {
        return attachments?.some((attachment) => attachment.canBeRemoved) || orthodonticReferral.isCopy;
    }


    const numberOfFiles = (num: number) => {
        setfilesSelected(num > 0);
    }
    const renderAttachmentRow = (attachment: IOrthodonticReferralAttachment, key: number) => {
        return <li key={key} className="row" onClick={() => downloadDocument(attachment.orthodonticReferralAttachmentId, attachment.name)} title={`Ladda ner ${attachment.name}`}>
            <div className={`col-11 ${!orthodonticReferral.isCopy ? "download" : ""}`}>
                <div className="row">
                    <p className="col-7">{attachment.name}</p>
                    <p className="col-2">{attachment.attachmentCategory}</p>
                    {
                        orthodonticReferral.isCopy
                            ?
                            <p className="col-2">
                                Kopierad fil
                                <HiddenInput name={`copiedFileIds[${key}]`} value={attachment.orthodonticReferralAttachmentId.toString()} />
                            </p>
                            : <span className="col-2 download-icon"><button onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faDownload} /></button></span>
                    }
                </div>
            </div>
            {
                attachment.canBeRemoved || orthodonticReferral.isCopy ?
                    <span className="col-1 remove-icon" onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        removeFile(attachment.orthodonticReferralAttachmentId);
                    }}><button><FontAwesomeIcon icon={faTrash} /></button></span>
                    : <span className="col-1"></span>
            }
        </li>
    }

    return (
        <div className="col-12">
            {
                attachments && attachments.length > 0 ?
                    <div className="row">
                        <label className="col-2">Uppladdade dokument:</label>
                        <div className="col-10">
                            <div className="row">
                                <div className="col-11">
                                    <div className="row">
                                        <h6 className="col-7">Fil</h6>
                                        <h6 className="col-2">Typ av bilaga</h6>
                                        <h6 className="col-2">Ladda ner</h6>
                                    </div>
                                </div>
                                {
                                    isAnyAttachmentRemovable() ?
                                        <div className="col-1">
                                            <h6>Ta bort</h6>
                                        </div>
                                        : null
                                }
                            </div>
                            <ul className="list-no-styling document-download-list">
                                {
                                    attachments?.map((attachment, index) =>
                                        renderAttachmentRow(attachment, index)
                                    )
                                }
                            </ul>
                            <div className="row">
                                <div className="col-11">
                                    <div className="row">
                                        <CustomButton disabled={!hasDownloadableDocuments()} 
                                            title={!hasDownloadableDocuments() ? "Det finns inga nerladdningsbara dokument" : ""} 
                                            buttonType={ButtonType.download} 
                                            buttonText="Ladda ner alla dokument" 
                                            onClick={() => downloadAllDocuments()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                canUploadFile() ?
                    <LibrettoFileUpload isEditable={true} attachmentCategories={orthodonticReferralAttachmentCategories ?? []} numOfFiles={numberOfFiles} />
                    : null
            }
            {
                filesSelected && orthodonticReferral.canUploadFileAsConsultant ?
                    <div className="row">
                        <div className="col-12 text-right">
                            <OrthodonticReferralUploadFilesConsultantButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getOrthodonticReferral={getOrthodonticReferral} orthodonticReferralId={orthodonticReferral.orthodonticReferralId} />
                        </div>
                    </div>
                    : null
            }
        </div>
    )
}